import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, ListItemText, MenuItem, Typography } from '@mui/material'
import { RouteImage } from '../../../../assets/routeImage'
import { useDispatch, useSelector } from 'react-redux'
import { NavigateFunction, useNavigate } from 'react-router-dom'

// COMPONENT
import Navbar from '../../Navbar'
import Header from '../../Header'
import { ButtonOutlined } from '../../../../component/mui-custom/MuiCustom'
import * as styled from '../../style/main.style'
import TableCustom from '../../../../component/table/tableCustom'
import TableRowCommon from '../../../../component/table/TableRowCommon'
// import HeaderTopicTable from '../../../../component/header-table/HeaderTopicTable'
import { disableStyleButtonMui } from '../../../../utils/disableStyleButton'
import Loading from '../../../../component/loading/Loading'
import ModalCustom from '../../../../component/modal/ModalCustom'
import AddPlan from './add-plan/AddPlan'
import EditPlan from './edit-plan/EditPlan'

// STORE
import { setLoading, unsetLoading } from '../../../../store/slice/loading/loading.slice'

// API
import { PlanApi, getPlansType, updatePlaneType } from '../../../../api/plan/plan.api';
import FilterSelect from '../../../../component/select/filterSelect'
import { swalError } from '../../../../component/notification/swal'

type Props = {}
const PlanSetting: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate: NavigateFunction = useNavigate();
    const isLoading = useSelector((state: any) => state?.loading?.isLoading);
    const permission = useSelector((state: any) => state?.permission?.permission);

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(5);
    const [totalItems, setTotalItems] = useState<number>(Number);
    const [plan, setPlan] = useState<any[]>([]);
    const [showModalAdd, setShowModalAdd] = useState<boolean>(false);
    const [showModalEdit, setShowModalEdit] = useState<boolean>(false);
    const [idPlan, setIdPlan] = useState<number>(Number);

    const handleToggleAdd = () => setShowModalAdd(!showModalAdd)
    const handleToggleEdit = () => setShowModalEdit(!showModalEdit)

    const handleChangeStatus = async (idPlan: number, status: string, planName: string, planNo: string) => {
        dispatch(setLoading())
        let condition: updatePlaneType = {
            planName: planName,
            planNo: planNo,
            planStatus: status
        }
        await PlanApi.updatePlan(idPlan, condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
                swalError(error?.response?.data?.description)
            })
            .finally(() => {
                handleGetPlan()
            })
    }
    const handleGetPlan = useCallback(async () => {
        dispatch(setLoading())
        let condition: getPlansType = {
            page: page,
            limit: pageLimit
        }
        await PlanApi.getPlans(condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    setTotalItems(res.data?.result?.meta?.totalItems)
                    setPlan(res?.data?.result?.items)
                    // console.log(res.data?.result?.items)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }, [page, pageLimit])

    const headCells = [
        {
            id: "RANK", width: 10, disablePadding: false, align: 'center', label:"ลำดับ"
        },
        {
            id: "PLAN", disablePadding: true, align: 'center', label:"แผน"
        },
        {
            id: "STATUS", disablePadding: true, width: 190, align: 'center', label:"สถานะ"
        },
        {
            id: "EDIT", disablePadding: false, align: "left", label: ""
        }
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const { idPlan, planName, planNo, planStatus } =
            objData;

        const objRenderData = {
            key: idPlan,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: planNo },
                { option: "TEXT", align: "left", label: planName },
                {
                    option: "TEXT", align: "left", label:
                        <FilterSelect
                            headingNormal
                            disabled={permission?.find((list: any) => list?.code === "Plan.Edit")?.permit === false}
                            renderValue={() =>
                                <ListItemText className='relative'>
                                    {planStatus === t("STATUS.ACTIVE") ? (
                                        <Typography
                                            className='text-light_success text-center after:left-[-0.5rem] after:translate-y-[-50%] after:top-1/2 after:absolute after:w-[6px] after:h-[6px] after:bg-light_success after:rounded-[50%]'>
                                            {t("STATUS.ACTIVE")}
                                        </Typography>
                                    ) : (
                                        <Typography
                                            className='text-danger text-center after:left-[-0.5rem] after:translate-y-[-50%] after:top-1/2 after:absolute after:w-[6px] after:h-[6px] after:bg-danger after:rounded-[50%]'>
                                            {t("STATUS.INACTIVE")}
                                        </Typography>
                                    )}
                                </ListItemText>
                            }
                            label={t('STATUS.LABEL')}
                            selectId="select-plan"
                            value={planStatus}
                            labelId="label-plan"
                            onchange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                                handleChangeStatus(idPlan, e.target.value, planName, planNo)}
                            options={[
                                <MenuItem key="1" value={t("STATUS.ACTIVE")}>
                                    <Typography className='text-light_success'><li>{t("STATUS.ACTIVE")}</li></Typography>
                                </MenuItem>,
                                <MenuItem key="2" value={t("STATUS.INACTIVE")}>
                                    <Typography className='text-danger'><li>{t("STATUS.INACTIVE")}</li></Typography>
                                </MenuItem>
                            ]}
                        />
                },
                {
                    option: "COMPONENT",
                    align: "right",
                    width: 10,
                    component:
                        <div
                            style={{
                                display: permission?.find((list: any) => list?.code === "Plan.Edit")?.permit === false ? 'none' : ''
                            }}
                            className='w-full flex justify-end gap-5'>
                            <Button
                                onClick={() => {
                                    handleToggleEdit()
                                    setIdPlan(idPlan)
                                }}
                                startIcon={<img src={RouteImage.editPen} />}
                                sx={disableStyleButtonMui}>{"แก้ไข"}</Button>
                        </div>
                }
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    useEffect(() => {
        handleGetPlan()
    }, [page, pageLimit])

    useEffect(() => {
        const permissionCheck = permission?.find((list: any) => list?.code === "Plan.Read")?.permit;
        if (permissionCheck === false) {
            navigate('/404');
        }
    }, [navigate])

    return (
        <styled.ContainerHome>
            {isLoading === true && <Loading />}
            <Navbar />
            {showModalAdd && (
                <ModalCustom
                    alignHeader='center'
                    enableExit={handleToggleAdd}
                    maxHeight='auto'
                    heading='เพิ่มแผนงาน'
                    component={<AddPlan fetchData={handleGetPlan} toggleModal={handleToggleAdd} />}
                />
            )}
            {showModalEdit && (
                <ModalCustom
                    alignHeader='center'
                    enableExit={handleToggleEdit}
                    maxHeight='auto'
                    heading='แก้ไขแผนงาน'
                    component={<EditPlan idPlan={idPlan} fetchData={handleGetPlan} toggleModal={handleToggleEdit} />}
                />
            )}
            <styled.MainContainer>
                <Header />
                <styled.Content>
                    <section className='flex justify-start items-start md:justify-between flex-col md:flex-row md:items-center gap-3'>
                        <Typography className='text-primary' variant='h4'>
                            แผนงาน
                        </Typography>
                        <ButtonOutlined
                            style={{
                                display: permission?.find((list: any) => list?.code === "Plan.Create")?.permit === false ? 'none' : ''
                            }}
                            onClick={handleToggleAdd}
                            sx={{ maxWidth: 75 }}
                            startIcon={<img src={RouteImage.addButton} />} >
                            <Typography className='text-primary'>{t("BUTTON.ADD")}</Typography>
                        </ButtonOutlined>
                    </section>

                    <section className='mt-8 w-full h-auto'>
                        {plan && (
                            <TableCustom
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy=""
                                sortType="ASC"
                                headCells={headCells}
                                rowCount={totalItems}
                                rowsData={plan && plan.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={() => { }}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        )}
                    </section>
                </styled.Content>
            </styled.MainContainer>

        </styled.ContainerHome>
    )
}

export default PlanSetting